<template>
  <PopperContainer
    :value="visible"
    @input="$emit('update:visible', $event)"
    title="风格选择"
    @confirm="onConfirm"
  >
    <div class="style-container">
      <div
        class="style-item"
        v-for="s in options"
        :key="s.speaker"
        @click="onPick(s)"
      >
        <img
          :class="[
            'avatar',
            {
              active: selectedValue === s.id,
            },
          ]"
          :src="s.styleAvatar"
          alt
        />
        <div
          class="image-widget"
          v-if="playState !== 'initial' && selectedValue === s.id"
        >
          <div
            :class="
              playState === 'paused'
                ? 'play-mask pause-animation'
                : 'play-mask play-animation'
            "
          >
            <div class="bar bar-one" style="background: #fff"></div>
            <div class="bar bar-two" style="background: #fff"></div>
            <div class="bar bar-three" style="background: #fff"></div>
          </div>
        </div>

        {{ s.styleName }}
      </div>
    </div>
  </PopperContainer>
</template>
<script>
import PopperContainer from "../popper-container/popper-container";
import { MAudio } from "@/utils/audio";
const VOICE_CACHE = {};
export default {
  components: {
    PopperContainer,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  inject: ["$editorPage"],
  created() {
    this.speakerAudio = MAudio.listen({
      playing: () => {
        this.playState = "playing";
      },
      pause: () => {
        this.playState = "paused";
      },
      ended: () => {
        this.playState = "initial";
      },
    });
  },
  data() {
    return {
      selectedValue: "",
      playState: "initial", // initial 初始态，没有播放   playing 正在播放    paused 暂停中
    };
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          const index = this.options.findIndex(
            (item) => item.id === this.value
          );
          if (index === -1 && this.options.length > 0) {
            this.selectedValue = this.options[0].id;
          } else {
            this.selectedValue = this.value;
          }
        }

        this.resetAudio();
      },
    },
  },
  methods: {
    onConfirm() {
      if (this.selectedValue !== this.value) {
        this.$emit("change", {
          value: this.selectedValue,
          option: this.options.find((item) => item.id === this.selectedValue),
        });
      }
    },

    onPick(moodSpeaker) {
      if (this.selectedValue === moodSpeaker.id) {
        if (this.playState === "initial") {
          // 重新开始播放
          this.playAudio(this.selectedValue);
        } else if (this.playState === "paused") {
          // 继续播放
          this.speakerAudio.play();
        } else if (this.playState === "playing") {
          // 暂停播放
          this.speakerAudio.pause();
        }
        return;
      }

      this.selectedValue = moodSpeaker.id;

      // 重置播放器状态
      this.resetAudio();

      // 试听
      this.playAudio(this.selectedValue);
    },

    resetAudio() {
      this.playState = "initial";
      this.speakerAudio.setSrc("");
      this.speakerAudio.stop();
    },
    playAudio(speakerId) {
      const getDemoUrl = VOICE_CACHE[speakerId]
        ? Promise.resolve(VOICE_CACHE[speakerId])
        : this.$editorPage
            .$http("getSpeakerInfo", {
              speakerId,
            })
            .then((res) => {
              let data = res.data;
              if (data && data.demoUrl) {
                VOICE_CACHE[speakerId] = data.demoUrl;
                return data.demoUrl;
              }
              return Promise.reject(res);
            });
      getDemoUrl
        .then((demoUrl) => {
          this.speakerAudio.setSrc(demoUrl);
          this.speakerAudio.play();
        })
        .catch((e) => {
          // 获取试听url出错
          console.log("获取试听url出错");
          console.log(e);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.style-container {
  .style-item {
    width: 25%;
    text-align: center;
    padding: 0;
    background: none;
    font-size: 26px;
    color: #666666;
    margin: 0;
    display: inline-block;
    margin-bottom: 20px;
    position: relative;

    .avatar {
      width: 108px;
      height: 108px;
      display: block;
      margin: auto;
      border: 2px solid transparent;
      border-radius: 100%;
    }

    .active {
      border-color: #3583fb;
    }
  }
}

.image-widget .play-mask {
  width: 108px;
  height: 108px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0px;
  bottom: 0;
  margin: 2px auto 0;
  // transform: translate(-50%);
  background: rgba(0, 0, 0, 0.49);
  border-radius: 50%;
}

/* 播放动画 */
@keyframes note1 {
  from {
    transform: scaleY(1);
  }

  to {
    transform: scaleY(2.5);
  }
}
.play-animation .bar {
  animation: note1 0.3s ease-in-out;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transform-origin: center bottom;
  width: 4px;
  height: 10px;
  margin: 0 5px;
  display: inline-block;
  background: rgba(70, 10, 237, 1);
}
.pause-animation {
  line-height: 100px;
  .bar {
    width: 4px;
    height: 25px;
    margin: 0 5px;
    display: inline-block;
    background: rgba(70, 10, 237, 1);
  }
}

.play-animation .bar-one {
  animation-delay: -0.15s;
}

.play-animation .bar-two {
  animation-delay: -0.3s;
}

.play-animation .bar-three {
  animation-delay: -0s;
}

.play-animation .bar-four {
  animation-delay: -0.2s;
}

.play-animation .bar {
  margin-top: 48px;
}
</style>